import { useContractRead } from 'wagmi';
import { getErcConfig } from '../api/config';
import ERC20_ABI from '../abis/abi.json';
import React from 'react';

export function useContract(address: `0x${string}`) {
  const [tokenAddress, setTokenAddress] = React.useState<`0x${string}` | null>(null);

  // 获取代币地址
  React.useEffect(() => {
    const fetchTokenAddress = async () => {
      try {
        const config = await getErcConfig();
        setTokenAddress(config.b_key as `0x${string}`);
      } catch (error) {
        console.error('获取代币地址失败:', error);
      }
    };
    fetchTokenAddress();
  }, []);

  // 读取代币余额
  const { data: balanceOf } = useContractRead({
    address: tokenAddress || '0x0000000000000000000000000000000000000000',
    abi: ERC20_ABI,
    functionName: 'balanceOf',
    args: [address],
  });

  return {
    balanceOf,
  };
} 